// export const SERVER_URL = 'http://localhost:3030/v1'
export const SERVER_URL = 'https://proalex.space/v1'

export const STATUS_INTERVAL_MS = 3000

export const STATUS = {
    RUNNING: 'running',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
}
